import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";

export class leanPlanningSegmentTableCtrl implements IController {
  segments: any;
  selectedIds: any;
  onAddAgents: Function;
  onChangeAgent: Function;
  onRemoveAgent: Function;
  onToggle: Function;

  public selectedKeys: any;

  constructor() {
  }

  $onChanges = (changes) => {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.selectedKeys = [];
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      })
    }
  }
}


angular
  .module('bringoz.admin.lean-planning')
  .component('leanPlanningSegmentTable', {
    bindings: {
      segments: '<',
      selectedIds: '<',
      onAddAgents: '&',
      onChangeAgent: '&',
      onRemoveAgent: '&',
      onToggle: '&'
    },
    template: require('./lean-planning-segment-table.html').default,
    controller: leanPlanningSegmentTableCtrl
  });
